import { ActionTypes } from '../actions';

const INITIAL_STATE = {
  resetError: false,
  emailSent: false,
  passwordResetSuccess: false,
  resetHash: null,
  resetEmail: '',
};

const PasswordReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.UPDATE_HASH:
      return {
        ...state,
        resetHash: action.payload.hash,
        resetEmail: action.payload.email,
      };
    case ActionTypes.EMAIL_SENT_SUCCESS:
      return {
        ...state,
        emailSent: true,
      };
    case ActionTypes.PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        passwordResetSuccess: true,
      };
    case ActionTypes.RESET_ERROR:
      return {
        ...state,
        resetError: true,
      };
    case ActionTypes.CLEAR_FORGOT_PASS_STATUSES:
      return {
        ...state,
        resetError: false,
        emailSent: false,
        passwordResetSuccess: false,
      };
    case ActionTypes.CLEAR_ALL_FORGOT_PASS:
      return {
        ...state,
        resetError: false,
        emailSent: false,
        passwordResetSuccess: false,
        resetEmail: '',
        resetHash: null,
      };
    default:
      return state;
  }
};

export default PasswordReducer;
